/*************************************************/
/* MOBILE-MENU                                   */
/*************************************************/
import customEventsNames from "../customEventsNames";
export function mobileMenu() {
    const bodyActiveClass = "mobile-menu-active";
    const mobileMenuSelector = ".menu-nav-mobile";
    const mobileMenuOpenTriggerSelector = ".menu-nav-mobile__trigger";
    const mobileMenuCloseTriggerSelector = ".menu-nav-mobile__close-button";
    const childItemsToggleSelector = ".menu-nav-mobile__child-items-toggle";
    const memberPanelToggleButtonSelector = '.menu-nav-mobile__member-panel-button';
    const memberPanelToggleButtonTargetSelector = '.member-panel__toggle';
    const mobileMenuMaskSelector = '.menu-nav-mobile__mask';

    const openMenu = () => {
        const mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenu.setAttribute('aria-hidden', false);
        document.body.classList.add(bodyActiveClass);

        const mobileMenuOpenedEvent = new Event(customEventsNames.mobileMenuOpened);
        mobileMenu.dispatchEvent(mobileMenuOpenedEvent);
    }

    const closeMenu = () => {
        const mobileMenu = document.querySelector(mobileMenuSelector);
        document.body.classList.remove(bodyActiveClass);
        mobileMenu.setAttribute('aria-hidden', true);
        const mobileMenuClosedEvent = new Event(customEventsNames.mobileMenuClosed);
        mobileMenu.dispatchEvent(mobileMenuClosedEvent);
    }

    const openSubMenu = (trigger, target) => {
        target.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', true);
    }

    const closeSubMenu = (trigger, target) => {
        target.setAttribute('hidden', 'hidden');
        trigger.setAttribute('aria-expanded', false);
    }

    const init = () => {
        
        //Handle clicking the mask
        const mask = document.querySelector(mobileMenuMaskSelector);
        if (mask) {
            mask.addEventListener('click', e => {
                closeMenu();
            });
        }

        //Handle opening the menu
        const openTrigger = document.querySelector(mobileMenuOpenTriggerSelector);
        if (openTrigger) {
            openTrigger.addEventListener('click', e => {
                openMenu();
            })
        }

        //Handle closing the menu
        const closeTrigger = document.querySelector(mobileMenuCloseTriggerSelector);
        if (closeTrigger) {
            closeTrigger.addEventListener('click', e => {
                closeMenu();
            })
        }

        //Handle opening and closing of all the menu items
        const childItemToggles = document.querySelectorAll(childItemsToggleSelector);
        if (childItemToggles) {
            childItemToggles.forEach(toggleItem => {
                toggleItem.addEventListener('click', e => {
                    const targetElement = document.getElementById(toggleItem.getAttribute('aria-controls'));
                    if (targetElement) {
                        if (targetElement.getAttribute('hidden') === 'hidden') {
                            openSubMenu(toggleItem, targetElement);
                        } else {
                            closeSubMenu(toggleItem, targetElement);
                        }
                    };
                });
            });
        }

        //Handle clicking the member button in the menu header
        const memberPanelToggle = document.querySelector(memberPanelToggleButtonSelector);
        if (memberPanelToggle) {
            memberPanelToggle.addEventListener('click', e => {
                const target = document.querySelector(memberPanelToggleButtonTargetSelector);
                if (target) {
                    closeMenu()
                    target.click();
                }
            })
        }

        //Close menu if screen width gets over breakpointMaxM (768px)
        var mediaQuery = window.matchMedia("(min-width: 768px)");
         mediaQuery.addEventListener("change", function() {
            closeMenu();
         }); 
    };

    init();
}
